import {
  GelBoxLayout,
  GelButton,
  GelHeading4,
  GelHeading5,
  GelIcon,
  GelLink,
  GelList,
  GelListItem,
  GelParagraph,
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import List from "components/components/List";
import Paragraph from "components/components/Paragraph";

const EarlyDetection = () => {
  return (
    <>
      {/* <CardHeader
        title="Skin cancer early detection"
        description="Regular skin checks can help maximise the chances of detecting skin cancer early."
        backgroundUrl="/images/skin-cancer-detection.jpg"
      ></CardHeader> */}
          
          <GelParagraph marginTop={getGelTokens().global.sizeBaseX6}>
              Living in Australia we have one of the highest incidences of skin cancer in the world<sup>2</sup>. However, there is good news; when detected early your chances of successful treatment are increased. But, in order to stop skin cancer spreading, it has to be spotted it in time<sup>2</sup>.
          </GelParagraph>
          <GelParagraph marginTop={getGelTokens().global.sizeBaseX6}>
              Unlike other cancers that develop in the body, skin cancer is a cancer you can usually see. It forms on the outside and is usually visible, giving it a good chance of being spotted.
          </GelParagraph>
          <GelParagraph marginTop={getGelTokens().global.sizeBaseX6}>
              By regularly self-checking your skin, you can help to identify the signs of skin cancer and maximise the chances of detecting skin cancer early. The first sign of a skin cancer can be a new spot, or an existing freckle or mole changing size, shape or colour over weeks or months <sup>2</sup>.
          </GelParagraph>
          <GelParagraph marginTop={getGelTokens().global.sizeBaseX6}>
              Getting to know your skin and what’s normal for you will help you find changes earlier. If you notice any sore, changing, abnormal or new spots or moles during your self-check, make sure to see your GP or dermatologist straight away for a skin assesment. In addition to self-checking regularly, it is also important to chat to your GP about your risk level of skin cancer and then, when necessary, book a skin check with your GP, dermatologist, or a skin cancer clinic <sup>2</sup>.
          </GelParagraph>

      {/* Insert Infographic */}

      {/* <SkinCheckCta /> */}

      <GelHeading5
        as="h2"
        marginBottom={getGelTokens().global.sizeBaseX6}
        marginTop={getGelTokens().global.sizeBaseX6}
      >
        What to look for at home
      </GelHeading5>
      <GelParagraph marginBottom={getGelTokens().global.sizeBaseX4}>
        <GelLink href="https://www.skincancercollege.org/" target="_blank">
          The Skin Cancer College of Australasia
        </GelLink>{" "}
        recommends you “SCAN” your skin looking for spots or moles that are:
      </GelParagraph>

      <GelList>
        <GelListItem>
          <b>SORE -</b> A spot which is sore (scaly, itchy, bleeding or tender) and doesn’t heal
          within 6 weeks
        </GelListItem>
        <GelListItem>
          <b>CHANGING - </b>In appearance (size, shape, colour or texture)
        </GelListItem>
        <GelListItem>
          <b>ABNORMAL -</b> Looks different, feels different, or stands out when compared to other
          spots and moles (e.g. the ‘Ugly Duckling’ – see below)
        </GelListItem>
        <GelListItem>
          <b>NEW -</b> Spots that have appeared recently
        </GelListItem>
      </GelList>

      <GelParagraph style={{ marginTop: 16 }}>
        <b>Ugly ducklings</b>: Most moles and spots on your body are the same or are similar-looking
        to each other. Compare your spots with other spots on your body. If any mole or spot stands
        out or looks noticeably different from that of surrounding spots, it is the “Ugly Duckling”,
        and should be professionally checked by a GP or dermatologist.
      </GelParagraph>

      <GelHeading5
        as="h2"
        marginBottom={getGelTokens().global.sizeBaseX6}
        marginTop={getGelTokens().global.sizeBaseX10}
      >
              How to check your skin at home⁶
      </GelHeading5>
      <GelParagraph marginBottom={getGelTokens().global.sizeBaseX4}>
        Here are simple steps to check and become familiar with your skin so you can identify any
        changes.
      </GelParagraph>

      <List
        content={
          "In a well-lit room, undress completely and use a full-length mirror to check your whole body, including areas not exposed to the sun\n" +
          "If you’re on your own, use a handheld mirror to check areas that are difficult to see, like your scalp and back, or ask a friend or family member to help\n" +
          "Spend extra time checking your face, neck, shoulders, back, arms, top of your hands, legs, soles of your feet and between your toes."
        }
      />

      <GelParagraph marginTop={getGelTokens().global.sizeBaseX4}>
        Visit the{" "}
        <GelLink
          href="https://www.cancer.org.au/cancer-information/causes-and-prevention/sun-safety/check-for-signs-of-skin-cancer"
          target="_blank"
        >
          Cancer Council
        </GelLink>{" "}
        for more skin-safe tips.{" "}
      </GelParagraph>
      {/* <GelParagraph marginTop={getGelTokens().global.sizeBaseX4}>
        In addition to regular checks at home, you should visit your GP or skin cancer clinic for a
        professional check. You can talk to them about your skin type and ask for advice on early
        detection. They can tell you how frequently you should be getting professional skin checks
        to complement your regular self-checks.
      </GelParagraph> */}

      {/* <GelParagraph
        marginBottom={getGelTokens().global.sizeBaseX4}
        marginTop={getGelTokens().global.sizeBaseX10}
      >
        *BOOKINGS ARE MADE THROUGH HEALTH DIRECT, A GOVERNMENT-FUNDED SERVICE.
        VISIT OUR HEALTH DIRECT FREQUENTLY ASKED QUESTIONS PAGE FOR MORE
        INFORMATION.
      </GelParagraph>
      <GelParagraph>
        STAPLES MP, ELWOOD M, BURTON RC, WILLIAMS JL, MARKS R, GILES GG.
        NON-MELANOMA SKIN CANCER IN AUSTRALIA: THE 2002 NATIONAL SURVEY AND
        TRENDS SINCE 1985 MED J AUST 2006 JAN 2;184(1):6-10. Contact TAL
      </GelParagraph> */}
    </>
  );
};

export default EarlyDetection;

const SkinCheckCta = () => {
  return (
    <GelBoxLayout
      width="100%"
      alignmentIndividual="center"
      alignment="center"
      vertical
      childStyle={{ width: "70%" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 20,
        }}
      >
        <GelIcon
          brand
          color={getGelTokens().brand.brandColorSecondary3}
          name="HealthHealthCheck"
          width={178}
          height={178}
        ></GelIcon>
        <GelHeading4>Get a professional skin check</GelHeading4>
        <GelParagraph textAlign="center">
          In addition to self-checking regularly, it is also important to get regular professional
          skin checks by your GP, dermatologist or a skin cancer clinic.
        </GelParagraph>
        {/* <GelButton primary medium>
          Book a skin check with a GP*{" "}
        </GelButton> */}
      </div>
    </GelBoxLayout>
  );
};
